<template>
  <section class="flex max-w-full w-screen min-h-screen">
    <portal-target name="dropdown" slim class="teste" />
    <div class="container_navigation w-80 min-h-screen fixed p-5 pb-5">
      <main-menu />
    </div>
    <div class="container_content w-full min-h-screen p-10">
      <div class="header w-full h-14 flex justify-between items-center mb-10 flex-wrap">
        <div class="flex items-center justify-center gap-7">
          <div class="cursor-pointer">
            <inertia-link href="/">
              <img src="/goback.svg" alt="Voltar" />
            </inertia-link>
          </div>
          <div class="h-10 w-52">
            <inertia-link href="/">
              <img :src="'/logo-slim-dark.png'" alt="Logo" class="w-full h-full" />
            </inertia-link>
          </div>
        </div>
        <div class="flex gap-3">
          <p>
            <span
              >Olá,
              <strong class="text-indigo">{{ $page.props.auth.user.first_name }}</strong></span
            >
            <span class="hidden md:inline"
              ><strong class="text-indigo">{{ $page.props.auth.user.last_name }}</strong></span
            >
          </p>
          <inertia-link :href="route('users.edit', $page.props.auth.user.id)">
            <icon class="w-5 h-5 ml-3" name="user" style="fill: #00a39a" />
          </inertia-link>

          <inertia-link :href="route('logout')" method="delete">
            <icon class="w-5 h-5 ml-3" name="exit" style="fill: #00a39a" />
          </inertia-link>
        </div>
      </div>
      <div class="">
        <flash-messages />
        <slot />
      </div>
    </div>
    <!-- <div class="md:flex md:flex-col">
      <div class="md:h-screen md:flex md:flex-col">
        <div class="md:flex md:flex-shrink-0">
          <div
            class="
              border-b
              w-full
              p-4
              md:py-0 md:px-12
              text-sm
              md:text-md
              flex
              justify-between
              items-center
            "
          >
            <div class="flex w-72 py-4">
              <dropdown class="md:hidden mr-4" placement="bottom-end">
                <svg
                  class="fill-gray-500 w-6 h-6"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
                </svg>

                <div slot="dropdown" class="mt-2 px-8 py-4 shadow-lg green-destination rounded">
                  <main-menu />
                </div>
              </dropdown>

              <inertia-link href="/">
                <img :src="'/logo-slim.png'" alt="Logo" />
              </inertia-link>
            </div>

            <div class="mt-1 mr-4">
              <a
                v-if="$page.props.auth.user.url"
                :href="$page.props.auth.user.url"
                class="btn-indigo ml-2"
                target="_blank"
                >Pesquisa de Demanda</a
              >
            </div>

            <div class="flex items-center select-none group">
              <div class="text-white mr-1 whitespace-nowrap">
                <span
                  >Olá,
                  <strong class="text-indigo">{{ $page.props.auth.user.first_name }}</strong></span
                >
                <span class="hidden md:inline"
                  ><strong class="text-indigo">{{ $page.props.auth.user.last_name }}</strong></span
                >
              </div>

              <inertia-link :href="route('users.edit', $page.props.auth.user.id)">
                <icon class="w-5 h-5 ml-3 fill-white" name="user" />
              </inertia-link>

              <inertia-link :href="route('logout')" method="delete">
                <icon class="w-5 h-5 ml-3 fill-white" name="exit" />
              </inertia-link>
            </div>
          </div>
        </div>

        <div class="md:flex md:flex-grow md:overflow-hidden bg-green-300" style="margin-top: -1px">
          <main-menu class="hidden md:block flex-shrink-0 w-56 green-destination overflow-y-auto" />

          <div class="md:flex-1 px-4 py-8 md:p-12 md:overflow-y-auto" scroll-region>
            <flash-messages />
            <slot />
          </div>
        </div>
      </div>
    </div> -->
  </section>
</template>

<script>
import Icon from '@/Shared/Icon'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    MainMenu,
  },
}
</script>

<style scoped>
section {
}

.container_navigation {
  min-width: 300px;
  max-width: 300px;
  height: 100vh;
}

.container_content {
  width: 100vw;
  max-width: 100%;
  padding-left: 340px;
}

@media screen and (max-width: 1000px) {
  section {
    display: flex;
    flex-direction: column;
  }

  .container_navigation {
    position: static;
    width: 100vw;
    max-width: 100%;
    min-height: 90px;
    height: 90px;
    background-color: #1e293b;
  }

  .container_content {
    padding-left: 20px;
    height: 100%;
  }
}
</style>
